// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__odKkW","logo":"sidebar_logo__DCETo","item":"sidebar_item__bh6Ja","logoutbtn":"sidebar_logoutbtn__gb4xf"};